import AboutInfo from "../components/sections/about/About";

const About = () => {
  return (
    <div>
      <AboutInfo />
    </div>
  );
};

export default About;
